<template>
  <div>
    <div class="row reorder-m">
      <div
        :class="[
          'timeline-col',
          'col',
          'm12',
          implisense_id ? news_focussed ? 'l4' : 'l8' : 'l12',
          'order-m-2',
          news_focussed ? 'unfocussed' : 'delayed-fade-in'
        ]"
        @click="news_focussed = false"
      >
        <div v-if="implisense_id" class="h3">
          {{ locales.registry_title}}
        </div>
        <div
          class="background-timeline"
        >
          <div
            v-if="!loading"
            id="timeline"
            :class="['timeline', { 'with-company-names': !implisense_id }]"
          >
            <div
              v-for="(item, index) in events"
              :key="index"
              class="timeline-container"
              :class="{
                'tl-left': index % 2 == 0,
                'tl-right': index % 2 == 1,
                'plus': item.plus
              }"
            >
              <div
                class ="company-name hide-on-small-only truncate"
                v-if="companies[item.implisense_id]"
              >
                <a
                  :href="companies[item.implisense_id].url"
                  :title="companies[item.implisense_id].name"
                >
                  {{ companies[item.implisense_id].name }}
                </a>
              </div>
              <div class="timeline-content">
                <div
                  :class="{ hide: item.plus }"
                  class="header p6 truncate"
                >
                  <time
                    v-if="item.date"
                    :datetime="item.date.split('+')[0]"
                    :data-datetime="item.date"
                  >
                    {{ `${item.date} (${item.type})` }}
                  </time>
                  <span
                    class ="hide-on-med-and-up"
                    v-if="companies[item.implisense_id]"
                  >
                    &bull;
                    <a
                      :href="companies[item.implisense_id].url"
                      :title="companies[item.implisense_id].name"
                    >
                      {{ companies[item.implisense_id].name }}
                    </a>
                  </span>
                </div>
                <div
                  class="height-10rem"
                  :class="{'expand': !item.plus}"
                  :data-show-more-text="locales.show_more"
                >
                  <img
                    v-if="item.plus"
                    class="left"
                    :src="icon_path"
                  >
                  <h4 class="p3 event-title">
                    {{ item.title }}
                  </h4>

                  <p v-if="item.category != 'MANAGEMENT_AND_TEAM' || user_access != 'public'" class="p4 event-text" v-html="item.text" />
                  <a
                    v-if="item.plus"
                    class="btn-small premium plus"
                    :href="user_access === 'personal' ? plus_href : pricing_path"
                  >
                    <i
                      class="material-icons left"
                      data-icon="add_circle"
                    />
                    {{ locales.teaser.cta }}
                  </a>
                </div>
                <div
                  class="divider"
                />
                <div
                  :class="{ hide: item.plus }"
                  class="footer"
                >
                  <p
                    v-if="!item.plus"
                    class="p6"
                  >
                    {{ locales.filters[item.type] }}
                  </p>
                  <template v-if="item.type === 'IMPLISENSE' && item.category.includes('FINANCES_AND_CAPITAL')">
                    <a
                      v-if="user_access === 'plus'"
                      :href="reports_path.replace(':implisense_id_placeholder', item.implisense_id)"
                      target="_blank"
                      :title="locales.show_report"
                    >
                      {{ locales.show_report }}
                    </a>
                    <a
                      v-else-if="user_access === 'personal'"
                      class='btn-small premium plus'
                      :href="plus_href"
                      :title="locales.show_report"
                    >
                      <i
                        class="material-icons left"
                        data-icon="add_circle"
                      />
                      {{ locales.show_report }}
                    </a>
                    <a
                      v-else
                      class='btn-small premium plus'
                      data-turbolinks="false"
                      rel="nofollow"
                      :href="pricing_path"
                      :title="locales.show_report"
                    >
                      <i
                        class="material-icons left"
                        data-icon="add_circle"
                      />
                      {{ locales.show_report }}
                    </a>
                  </template>
                  <a
                    v-else-if="item.type !== 'HRB'"
                    :href="item.source"
                    target="_blank"
                    rel="noopener nofollow"
                    :title="item.publisher"
                  >
                    {{ item.publisher }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="loading"
            class="div-align-center"
          >
            <loading />
          </div>
        </div>

      </div>
      <div
        v-if="implisense_id"
        :class="[
          'timeline-col',
          'col',
          'm12',
          news_focussed ? 'l8' : 'l4',
          'order-m-1',
          news_focussed ? 'delayed-fade-in' : 'unfocussed'
        ]"
        @click="news_focussed = true"
      >
        <div class="h3">
          {{ locales.news_title}}
        </div>
        <p>
          {{ locales.news_agent_public_teaser }}
        </p>
        <div
>
          <form
            ref="newsForm"
            method="post"
            :hx-post=news_search_path
            hx-target="#news-search-results"
            hx-swap="outerHTML"
            hx-indicator="#news-search-spinner"
            hx-disabled-elt="#message-field, #submit-button"
            @submit.prevent="submitWithChallenge"
          >
            <input type="hidden" autocomplete="off" name="c" :value="news_search_challenge">
            <input type="hidden" autocomplete="off" name="x" v-model="x">
            <div class = "input-field">
              <input
                type ="text"
                id="message-field"
                name="message"
                maxlength="200"
                :placeholder=locales.news_agent_placeholder
                v-model="message"
              >
            </div>
            <div id="h-filter" class="input-field" autocomplete="off">
              <input
                type ="text"
                name="name"
                maxlength="100"
              >
            </div>
            <input
              type="hidden"
              name="preview"
              :value="preview_timeline"
            >
            <div class="section">
              <button id="submit-button" class="btn" type="submit">
                <i class="material-icons left" data-icon="view_compact"></i>
                {{ locales.news_agent_cta}}
              </button>
            </div>
          </form>
          <div
            id = "news-search-spinner"
            class = "htmx-indicator"
          >
            <div id = "news-search-spinner-wrapper">
              <div class = "preloader-wrapper active">
                <div class = "spinner-layer spinner-blue-only">
                  <div class = "circle-clipper left">
                    <div class = "circle"></div>
                  </div>
                  <div class = "gap-patch">
                    <div class = "circle"></div>
                  </div>
                  <div class = "circle-clipper right">
                    <div class = "circle"></div>
                  </div>
                </div>
              </div>
              <p class="news-search-spinner-text">
                {{ currentSpinnerText }}
              </p>
            </div>
          </div>
          <div id="news-search-results">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
            <div
          v-if="preview_timeline && !loading"
          class="timeline-footer"
        >
          <a
            v-if="events && events.length"
            :href="user_access === 'public' ? login_path : events_path"
            :data-track-event="user_access === 'public' ? 'registration' : null"
            :data-track-properties="user_access === 'public' ? JSON.stringify({ context: 'timeline', referer: original_url }) : null"
            class="btn primary"
          >
            <i
              class="material-icons left rotate90-mirrorX"
              data-icon="linear_scale"
            />
            {{ locales.show_all_events }}
          </a>
        </div>
    </div>
  </div>
</template>
<script>
import Loading from '../loading.vue'
import SHA256 from 'crypto-js/sha256'
import Hex from 'crypto-js/enc-hex'

export default {
  components: {
    Loading
  },
  props:{
    initial_locales: {
      type: String,
      default: ''
    },
    initial_events: {
      type: String,
      default: ''
    },
    implisense_id: {
      type: String,
      default: null
    },
    company_list_id: {
      type: String,
      default: null
    },
    initial_companies: {
      type: String,
      default: '{}'
    },
    preview_timeline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '5'
    },
    events_path: {
      type: String,
      default: '#'
    },
    login_path: {
      type: String,
      default: '#'
    },
    user_access: {
      type: String,
      default: 'public'
    },
    initial_personal_filters: {
      type: String,
      default: ''
    },
    initial_filters: {
      type: String,
      default: ''
    },
    icon_path: {
      type: String,
      default: ''
    },
    plus_href: {
      type: String,
      default: ''
    },
    pricing_path: {
      type: String,
      default: ''
    },
    reports_path: {
      type: String,
      default: '',
    },
    news_search_path: {
      type: String,
      default: ''
    },
    news_search_challenge: {
      type: String,
      default: ''
    },
    original_url: {
      type: String,
      default: ''
    }
  },
  data() {
    let locales = JSON.parse(this.initial_locales)
    let events = JSON.parse(this.initial_events)
    if (events) {
      events = events.slice(0, this.size)
    }
    return {
      loading: false,
      events: events,
      companies: JSON.parse(this.initial_companies),
      locales: locales,
      personal_filters: JSON.parse(this.initial_personal_filters),
      filters: JSON.parse(this.initial_filters),
      news_focussed: false,
      spinner_texts: locales.spinner_texts,
      current_spinner_text_index: 0,
      x: '',
      message: '',
      is_submitting: false
    }
  },
  mounted(){
    this.loading = true
    if (this.user_access === 'personal' || this.user_access === 'public') {
      this.filters = this.personal_filters
    }
    this.loadEvents(this.filters)
    this.$nextTick(() => {
      if (this.$refs.newsForm) {
        window.htmx.process(this.$refs.newsForm)
      }
    })
  },
  updated() {
    window.expandable()
  },
  beforeMount() {
    if (this.user_access === 'personal' || this.user_access === 'plus') {

      this.subscription = window.App.cable.subscriptions.create(
        {
          ...{ channel: 'EventsChannel' },
          user_access: this.user_access,
          ...this.identifier()
        },
        {
          received: data => {
            if (this.filters.length) {
              if (JSON.stringify(data.filters) !== JSON.stringify(this.filters) || (data.implisense_id && data.implisense_id !== this.implisense_id) || (data.company_list_id && data.company_list_id !== this.company_list_id)) {
                return
              }
            }
            if (this.filters.length > 0) {
              this.events = data.events.slice(0, this.size)
            } else {
              this.events = []
            }
            if (this.user_access === 'personal' && (this.events !== null && this.events.length)) {
              this.addPlusObjectToEvents()
            }
            this.loading = false
          },
        }
      )
    }

    if (this.user_access != 'plus' && (this.events !== null && this.events.length)) {
      this.addPlusObjectToEvents()
    }
  },
  beforeDestroy() {
    window.App.cable.subscriptions.remove(this.subscription)
  },
  computed: {
    currentSpinnerText() {
      return this.spinner_texts[this.current_spinner_text_index]
    }
  },
  methods: {
    identifier() {
      if (this.implisense_id) {
        return { implisense_id: this.implisense_id }
      } else if (this.company_list_id) {
        return { company_list_id: this.company_list_id }
      }
    },
    resetFilters() {
      if (this.user_access === 'personal') {
        this.loadEvents(this.personal_filters)
        this.$refs['event-filters'].resetFilters(this.personal_filters)
      } else {
        this.loadEvents(JSON.parse(this.initial_filters))
        this.$refs['event-filters'].resetFilters(JSON.parse(this.initial_filters))
      }
    },
    loadEvents(updatedFilters) {
      this.filters = updatedFilters
      if (this.user_access != 'public') {
        if (!updatedFilters.length) {
          this.events = []
          this.loading = false
          return
        }
        this.loading = true
        this.subscription.send({
          filters: updatedFilters,
          size: this.size,
          user_access: this.user_access
        })
      } else {
        this.loading = false
      }
    },
    addPlusObjectToEvents() {
      const plusObject = {
        category: 'PLUS',
        text: this.locales.teaser.content,
        title: this.locales.teaser.title,
        plus: true
      }
      let newList = [...this.events]
      newList.splice(1, 0, plusObject)
      this.events = newList
    },
    setLoading(state) {
      this.loading = state
    },
    setIconInContainer(icon) {
      switch (icon) {
      case 'NAME_AND_ADDRESS':
        return 'location_city'
      case 'PURPOSE_AND_INDUSTRY':
        return 'work'
      case 'MANAGEMENT_AND_TEAM':
        return 'group'
      case 'FINANCES_AND_CAPITAL':
        return 'attach_money'
      case 'MERGERS_AND_ACQUISITIONS':
        return 'call_merge'
      case 'BANKRUPTCY':
        return 'remove_circle'
      case 'NEWS_AND_EVENTS':
        return 'trending_up'
      case 'PRODUCTS':
        return 'new_releases'
      case 'CUSTOMERS_AND_PARTNERS':
        return 'groups'
      case 'RESEARCH_AND_TECHNOLOGY':
        return 'memory'
      case 'LOCATIONS_AND_INTERNATIONAL':
        return 'place'
      case 'LEGAL':
        return 'assignment_late'
      case 'PLUS':
        return 'add'
      default:
        return 'account_balance'
      }
    },
    startNewsSpinner() {
      this.current_spinner_text_index = 0
      this.incrementNewsSpinner()
    },
    incrementNewsSpinner() {
      setTimeout(() => {
        if (this.current_spinner_text_index < this.spinner_texts.length - 1) {
          this.current_spinner_text_index++
          this.incrementNewsSpinner()
        }
      }, 3000)
    },
    async submitWithChallenge() {
      if (this.is_submitting) return
      this.is_submitting = true
      const salt = Math.random().toString(36).substring(2, 10)
      const input = this.news_search_challenge + salt + this.message
      const hash = SHA256(input).toString(Hex)
      this.x = salt + hash

      this.startNewsSpinner()
      this.$nextTick(() => {
        htmx.trigger(this.$refs.newsForm, 'submit')
        this.is_submitting = false
      })
    },
  }
}
</script>
